/* eslint no-console:0 */

import "@hotwired/turbo-rails";

import Rails from "@rails/ujs";
Rails.start();

import LocalTime from "local-time";
LocalTime.start();

// Utility function to require all files in a directory...
function requireAll(r) {
  r.keys().forEach(r);
}

// Require everything in our modules directory
requireAll(require.context("./shared/modules/", true, /\.js$/));
requireAll(require.context("./self_service/modules/", true, /\.js$/));

// support older browsers like Internet Explorer 11
import "@stimulus/polyfills";

// Set up Stimulus and import controllers
import { Application } from "stimulus";
import { definitionsFromContext } from "stimulus/webpack-helpers";
const application = Application.start();
const controllers = require.context("./self_service/controllers", true, /.js$/);
// Also load shared controllers
const shared = require.context("./shared/controllers", true, /.js$/);
application.load(
  definitionsFromContext(controllers).concat(definitionsFromContext(shared))
);

// Import our app CSS
import "css/self_service";
